import OrderDataLayer from './OrderDataLayer';
import { FlightSegment } from '@websky/graphql';
import { OrderStep } from '../types';
import { OrderType } from './types';

class StubOrderDataLayer extends OrderDataLayer {
	public constructor() {
		super(null);
	}

	public getOrderType(): OrderType {
		return null;
	}

	public getFlightSegments(): FlightSegment[] {
		return [];
	}

	public getOrderStatus(): OrderStep {
		return undefined;
	}

	public isInitialized(): boolean {
		return false;
	}

	public setOrder(order: {}) {
		// Not implemented
	}
}

export default StubOrderDataLayer;
